// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3phw0","disabled":"FileBtn_disabled__1Nb_l","warn":"FileBtn_warn__2SIrr","fade":"FileBtn_fade__30ezU"};